import { __assign, __read, __rest } from "tslib";
import React, { Fragment, useCallback, useState, } from 'react';
import Radio from './Radio';
var noop = function () { };
var noOptions = [];
export default function RadioGroup(props) {
    var onChange = props.onChange, _a = props.options, options = _a === void 0 ? noOptions : _a, propValue = props.value, defaultValue = props.defaultValue, isDisabled = props.isDisabled, isRequired = props.isRequired, _b = props.onInvalid, onInvalid = _b === void 0 ? noop : _b, name = props.name, analyticsContext = props.analyticsContext;
    var _c = __read(useState(propValue !== undefined ? propValue : defaultValue), 2), selectedValue = _c[0], setSelectedValue = _c[1];
    var onRadioChange = useCallback(function (e, analyticsEvent) {
        setSelectedValue(e.currentTarget.value);
        if (onChange) {
            onChange(e, analyticsEvent);
        }
    }, [onChange]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    var value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return (React.createElement(Fragment, null, options.map(function (_a, index) {
        var optionProps = __rest(_a, []);
        if (typeof isDisabled !== 'undefined') {
            optionProps.isDisabled = isDisabled;
        }
        var isChecked = value != null && optionProps.value === value;
        return (React.createElement(Radio, __assign({}, optionProps, { name: name || optionProps.name, key: index, onChange: onRadioChange, onInvalid: onInvalid, isChecked: isChecked, isRequired: isRequired, analyticsContext: analyticsContext })));
    })));
}
//# sourceMappingURL=RadioGroup.js.map